import React from 'react';
import Legend from 'components/common/Legend';
import WidgetChart from 'components/common/WidgetChart';
import { widgetConfig } from 'constants/Compare/widgetConfig';
import LoadingSpinner from 'components/common/LoadingSpinner';
class CompareOverview extends React.Component {
  getDomain(name) {
    switch (name) {
      case 'Sovereign wealth funds':
      case 'Taxation':
        return 70;
      case 'Revenue management':
        return 80;
      default: return 100;
    }
  }

  getAxisValues(max) {
    const add = max / 5;
    const domain = [0];

    for (let i = 1; i < 5; i++) {
      domain.push(Math.ceil(domain[i - 1] + add));
    }
    domain.push(max);
    return domain;
  }

  setCustomAxis(max) {
    let axisY = {};
    const staticAxes = widgetConfig.axes.filter((a) => {
      if (a.scale === 'y') axisY = Object.assign({}, a);
      return a.scale !== 'y';
    });
    axisY.values = this.getAxisValues(max);
    staticAxes.push(axisY);
    return staticAxes;
  }

  setCustomScales(max) {
    let scaleY = {};
    const staticScales = widgetConfig.scales.filter((s) => {
      if (s.name === 'y') scaleY = Object.assign({}, s);
      return s.name !== 'y';
    });
    scaleY.domain = [0, max];
    staticScales.push(scaleY);
    return staticScales;
  }

  setCustomData(data) {
    return Object.assign(
      {},
      widgetConfig.data[0],
      { values: data }
    );
  }

  parseitem(item) {
    const newItems = [];
    item.values.forEach((val, i) => {
      if (val.value === undefined) {
        newItems.push({
          x: `${i + 1}`, y: 0, avg: -20
        });
      } else {
        newItems.push({ x: val.country, y: val.value, avg: item.avg || -20, name: item.name });
      }
    });
    return newItems;
  }

  parseConfig(data, max) {
    return Object.assign({}, widgetConfig, {
      data: [this.setCustomData(data)],
      scales: this.setCustomScales(max),
      axes: this.setCustomAxis(max)
    });
  }

  render() {
    return (
      <div className="l-country-overview">
        {this.props.loading && <LoadingSpinner inner transparent />}
        <div className="row">
          <div className="column small-12 medium-6">
            {this.props.title &&
              <h2 className="title -module-title -light">
                {this.props.title}
              </h2>
            }
            {this.props.text &&
              <p className="intro -light">
                {this.props.text}
              </p>
            }
          </div>
        </div>

        <div className="c-compare-overview-wrapper">
          <div className="row">
            {this.props.data.overview.map((item, index) => {
              const parsedItem = this.parseitem(item);
              const max = 100;

              return (
                <div key={index} className="column small-12 medium-4 large-3">
                  <WidgetChart
                    title={item.name}
                    toggleLoading={() => {}}
                    widgetConfig={this.parseConfig(parsedItem, max)}
                  />
                </div>
              );
            })}
          </div>
          <div className="row">
            <div className="column small-12">
              <Legend data={this.props.data.legend} theme={this.props.theme} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CompareOverview.propTypes = {
  text: React.PropTypes.string,
  theme: React.PropTypes.string,
  title: React.PropTypes.string,
  transparent: React.PropTypes.bool,
  loading: React.PropTypes.bool,
  data: React.PropTypes.shape({
    overview: React.PropTypes.array.isRequired,
    legend: React.PropTypes.array.isRequired
  }).isRequired
};

export default CompareOverview;



// WEBPACK FOOTER //
// ./app/components/common/compare-overview/index.jsx